module.exports = __webpack_public_path__ + "static/media/note.6c6cd3c0.svg";